/** @format */

import React, {useState} from 'react';
import Modal from '../../../account/components/feedback/modal/modal';
import FeedbackForm from '../feedback_form/container';
import './feedback.sass';
import {BrowserView, MobileView} from 'react-device-detect';

const Feedback = () => {
    const [isModalOpen, toggleModal] = useState(false);
    const [isFeedbackSelected, toggleFeedback] = useState(false);
    let bhFunction = () => {
        _bugHerd.win.bugherd.applicationView.anonymousbar.toggleOptions();
    };

    let pathName = window.location.pathname;
    return (
        <div>
            {pathName !== '/orders/custom-labels' && (
                <BrowserView>
                    <button
                        className="btn feedback-btn"
                        onClick={() => {
                            toggleModal(true);
                            toggleFeedback(false);
                        }}>
                        <h6 style={{margin: '0', color: '#fff'}}>Report Issue</h6>
                    </button>
                </BrowserView>
            )}
            {isModalOpen && (
                <Modal
                    closeBtn={false}
                    onClose={() => {
                        toggleModal(false);
                        toggleFeedback(false);
                    }}
                    disableOverlayClick={false}>
                    <div className="feedback-container">
                        <a
                            className="feedback-bug bug-box"
                            onClick={() => {
                                if (typeof Beacon !== 'undefined') {
                                    // Beacon is a helpsscount function
                                    // https://developer.helpscout.com/beacon-2/web/javascript-api/
                                    Beacon('open');
                                    toggleModal(false);
                                    toggleFeedback(false);
                                }
                            }}>
                            <h4>Get help with an order</h4>
                        </a>
                        <div
                            className="feedback-bug feedback-box"
                            onClick={() => toggleFeedback(true)}>
                            <h4>Contact CEO directly</h4>
                        </div>
                        {isFeedbackSelected && (
                            <div className="send-feedback-overlay">
                                <FeedbackForm
                                    toggleFeedback={toggleFeedback}
                                    toggleModal={toggleModal}
                                    bhClick={bhFunction}
                                />
                            </div>
                        )}
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default Feedback;
